import { render, staticRenderFns } from "./PersonPicker.vue?vue&type=template&id=609e94ba&scoped=true"
import script from "./PersonPicker.vue?vue&type=script&lang=js"
export * from "./PersonPicker.vue?vue&type=script&lang=js"
import style0 from "./PersonPicker.vue?vue&type=style&index=0&id=609e94ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e94ba",
  null
  
)

export default component.exports